import React from 'react';
import { Card, Div, LoadingWrapper, ModalTitle, SubTitle, Wrapper, WrapperModal } from './style';
import { useStore } from '../../providers/store.provider';
import {
  fetchProductsCategories,
  postReplicateMenu,
  postReplicateProduct
} from '../../redux/actions/products';
import { useEffect } from 'react';
import StepOrigin from './steps/Origin';
import StepDestiny from './steps/Destiny';
import { getStoreInformations } from '../../utils/stores';
import StepSummary from './steps/Summary';
import { useDispatch } from 'react-redux';
import { Modal } from 'vqp-common';
import { Button, Icon, Loading } from '../../components/common';
import { fetchStoreMultistore } from '../../redux/actions/store';

const ReplicateMenuPage = () => {
  const dispatch = useDispatch();
  const storeProvider = useStore();
  const [categories, setCategories] = React.useState(null);
  const [products, setProducts] = React.useState(null);
  const [isMultistore, setIsMultistore] = React.useState(true);
  const [valueStep, setValueStep] = React.useState('origin');
  const [valueReplicate, setValueReplicate] = React.useState(null);
  const [valueDestiny, setValueDestiny] = React.useState('');
  const [selectedCategorie, setSelectedCategorie] = React.useState(null);
  const [selectedProduct, setSelectedProduct] = React.useState(null);
  const selectedMultistore = storeProvider.selectedMultistore;
  const [optionSelected, setSelected] = React.useState();
  const [stores, setStores] = React.useState([]);
  const [FinishModalOpen, setFinishModalOpen] = React.useState(false);
  const [loading, setLoading] = React.useState();

  useEffect(() => {
    dispatch(fetchStoreMultistore()).then((response) => {
      if (response.success) {
        setStores(response.payload.stores);
      }
    });
  }, []);

  useEffect(() => {
    if (selectedMultistore?.id) fetchCategories(selectedMultistore.id);
  }, [selectedMultistore]);

  useEffect(() => {
    if (selectedCategorie !== undefined && valueReplicate === 'product') {
      const selectProducts = categories.filter((cat, index) => index === selectedCategorie);
      setProducts(selectProducts[0]?.products);
    }
  }, [selectedCategorie]);

  const fetchCategories = (multistoreId) => {
    dispatch(fetchProductsCategories(multistoreId)).then((response) => {
      if (response.success) {
        setCategories(response.data);
      }
    })
  };

  const handleChangeStores = (selected) => {
    setSelected(selected);
  };

  const handleChange = (newValue) => {
    setValueStep(newValue);
  };

  const handleChangeReplicate = (newValue) => {
    setValueReplicate(newValue);
  };

  const handleChangeReplicateDestiny = (newValue) => {
    setValueDestiny(newValue);
  };

  const handleSelectCategorie = (categorieId) => {
    setSelectedCategorie(categorieId);
  };

  const handleSelectProduct = (productId) => {
    setSelectedProduct(productId);
  };

  const handlePostReplicate = () => {
    setLoading(true);
    const storeIds =
      valueDestiny === 'all_units'
        ? stores.map((store) => store.id)
        : optionSelected.map((store) => store.value);

    if (valueReplicate === 'product') {
      const product = products.find((product, index) => index === selectedProduct);
      const result = dispatch(postReplicateProduct(storeIds, product.id));
      Promise.resolve(result)
        .then(() => {
          setValueStep('origin');
          setValueReplicate(null);
          handleOpenDetailModal();
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    } else if (valueReplicate === 'replicate') {
      const getStoreInfo = getStoreInformations();

      const data = {
        IdBase: getStoreInfo.id,
        EstabelecimentosId: storeIds
      };
      const result = dispatch(postReplicateMenu(data));
      Promise.resolve(result)
        .then(() => {
          setValueStep('origin');
          setValueReplicate(null);
          handleOpenDetailModal();
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };

  const handleOpenDetailModal = () => {
    setFinishModalOpen(true);
  };

  const handleCloseDetailModal = () => {
    setFinishModalOpen(false);
  };

  return (
    <>
      {loading && (
        <LoadingWrapper>
          <Loading />
        </LoadingWrapper>
      )}
      <Wrapper>
        <Card>
          <SubTitle>
            <Div className={valueStep === 'origin' ? 'selected' : ''}>Origem</Div>
            <Div className={valueStep === 'destiny' ? 'selected' : ''}>Destino</Div>
            <Div className={valueStep === 'summary' ? 'selected' : ''}>Resumo</Div>
          </SubTitle>
          <hr></hr>

          {valueStep === 'origin' && (
            <StepOrigin
              valueReplicate={valueReplicate}
              handleChangeReplicate={handleChangeReplicate}
              categories={categories}
              selectedCategorie={selectedCategorie}
              handleSelectCategorie={handleSelectCategorie}
              products={products}
              selectedProduct={selectedProduct}
              handleSelectProduct={handleSelectProduct}
              handleChange={handleChange}
            />
          )}

          {valueStep === 'destiny' && (
            <StepDestiny
              handleChange={handleChange}
              valueDestiny={valueDestiny}
              handleChangeReplicateDestiny={handleChangeReplicateDestiny}
              isMultistore={isMultistore}
              optionSelected={optionSelected}
              handleChangeStores={handleChangeStores}
              stores={stores}
            />
          )}

          {valueStep === 'summary' && (
            <StepSummary
              handleChange={handleChange}
              valueReplicate={valueReplicate}
              valueDestiny={valueDestiny}
              optionSelected={optionSelected}
              handlePostReplicate={handlePostReplicate}
            />
          )}
          <Modal
            isOpen={FinishModalOpen}
            onClose={handleCloseDetailModal}
            boxWidth={'800px'}
          >
            <WrapperModal>
              <Icon
                width={'56px'}
                height={'56px'}
                name={'replicateSuccess'}
                stroke={'primary'}
              />
              <ModalTitle>Ação em andamento</ModalTitle>
              <p>O processo pode demorar alguns minutos para ser finalizado.</p>
              <Button
                className="success"
                width={'80px'}
                onClick={handleCloseDetailModal}
                style={{ marginTop: '15px' }}
              >
                Continuar
              </Button>
            </WrapperModal>
          </Modal>
        </Card>
      </Wrapper>
    </>
  );
};

export default ReplicateMenuPage;
